import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { PlacesApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { placeGroupQueryKeys } from './queryKeys'

type Params = {
  /**
   * 除外の基準となる編集対象（新規作成時は親）の現場グループノード UUID。
   * 指定するとこのノードが属する最上位ツリーに所属済みの現場が除外される。
   * 新規ルート直下グループの場合など未指定なら除外しない。
   */
  targetGroupNodeUuid: string | undefined
  /** 現場名の部分一致検索文字列。 */
  placeName: string
}

/**
 * 現場グループ編集の「所属させる現場」候補を取得する。
 *
 * 除外（編集対象グループが属する最上位ツリーに所属済みの現場を候補から外す）を
 * サーバー側（取得時）で行う専用エンドポイント GET /v2/places/assignable を叩く。
 * これにより 600 件の取得上限が「選択可能な現場」に対して使われる（SHIEN-653）。
 */
export const useQueryAssignablePlaces = ({
  targetGroupNodeUuid,
  placeName,
}: Params) => {
  return useQuery({
    queryKey: placeGroupQueryKeys.assignablePlaces(
      targetGroupNodeUuid,
      placeName,
    ),
    queryFn: async () => {
      return await baseClient
        .getApi(PlacesApi)
        .getAssignablePlaces({
          targetGroupNodeUuid,
          placeName: placeName || undefined,
        })
        .catch(handleHTTPError)
    },
    // 検索文字列の変更時に候補リストが一瞬空になる（ちらつく）のを防ぐ
    placeholderData: keepPreviousData,
  })
}
